module.exports = __webpack_public_path__ + "img/Diego_Montoya.da50854c.jpg";